import { NgbDateStruct, NgbDateParserFormatter, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { UtilsService } from '../utils.service';

@Component({
  selector: 'cygov-assessment-duration-calendar',
  templateUrl: './assessment-duration-calendar.component.html',
  styleUrls: ['./assessment-duration-calendar.component.scss'],
  standalone: false,
})
export class AssessmentDurationCalendarComponent implements OnInit {
  @Input() startDate: number = null;
  @Input() endDate: number = null;
  @Input() disableAll: number = 0; // 1 = disable Start Calendar, 2 = disable End Calendar , 3 disable both
  @Input() isFromReassessment: boolean = false; // 1 = disable Start Calendar, 2 = disable End Calendar , 3 disable both
  @Input() disableStartDate: boolean = false;
  @Input() disableEndDate: boolean = false;
  @Input() allowPastStartDate: boolean = false;
  @Output() startDateChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() endDateChanged: EventEmitter<number> = new EventEmitter<number>();
  startDateCalendar: NgbInputDatepicker;
  endDateCalendar: NgbInputDatepicker;

  currentDateSet: NgbDateStruct = null;
  selectedStartDate: NgbDateStruct = null;
  startDateToShow: NgbDateStruct = null;
  selectedEndDate: NgbDateStruct = null;
  endDateToShow: NgbDateStruct = null;

  constructor(private parserFormatter: NgbDateParserFormatter) {}

  ngOnInit(): void {
    const currentDate = Date.now();
    this.startDate = this.startDate ? this.startDate : currentDate;
    this.endDate = this.endDate ? this.endDate : currentDate;
    if (this.endDate < currentDate) {
      const oneDayInMilliseconds = 24 * 60 * 60 * 1000; // Milliseconds in one day
      this.endDate = currentDate + oneDayInMilliseconds;
    }

    this.selectedStartDate = UtilsService.getDateInNgbDateStructFormat(new Date(this.startDate));
    this.selectedEndDate = UtilsService.getDateInNgbDateStructFormat(new Date(this.endDate));
    this.currentDateSet = UtilsService.getDateInNgbDateStructFormat(new Date(currentDate));
  }

  setCalendarRef(ref: NgbInputDatepicker, type: boolean): void {
    if (type) {
      this.startDateCalendar = ref;
      this.startDateCalendar.open();
      this.startDateCalendar.navigateTo(this.selectedStartDate);
    } else {
      this.endDateCalendar = ref;
      this.endDateCalendar.open();
      this.endDateCalendar.navigateTo(this.selectedEndDate);
    }
  }

  getDateinDateFormat(date: NgbDateStruct): Date {
    return new Date(date.year, date.month - 1, date.day);
  }

  changeDate(date: NgbDateStruct, key: string): void {
    if (key === 'startDate') {
      this.selectedStartDate = date;
      const formattedDate = this.parserFormatter.format(date);
      this.startDate = new Date(formattedDate).getTime();
      // initializing end date calendar if start date is ahead of selected end date.
      if (this.startDate > this.endDate) {
        this.selectedEndDate = this.selectedStartDate;
      }

      this.startDateChanged.emit(this.startDate);

      // setTimeout(() => {
      //   this.endDateCalendar.close();
      //   this.endDateCalendar.open();
      //   this.endDateCalendar.navigateTo(this.selectedEndDate);
      // }, 50);
    } else {
      this.selectedEndDate = date;
      const formattedDate = this.parserFormatter.format(date);
      this.endDate = new Date(formattedDate).getTime();
      // this.startDateChanged.emit(this.startDate);
      this.endDateChanged.emit(this.endDate);
      // const currentDate = Date.now();
      // this.currentDateSet = UtilsService.getDateInNgbDateStructFormat(new Date(currentDate));
      // this.selectedEndDate = UtilsService.getDateInNgbDateStructFormat(new Date(this.endDate));
    }
  }

  calendarNavigateTrigger(event, date: NgbDateStruct): void {
    date.month = event.next.month;
    date.year = event.next.year;
  }
}
